import { Injectable } from "@angular/core";

import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import {
  HttpEvent,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from "@angular/common/http";
import { AuthenticationService } from "../_services/authentication.service";
import { ActivatedRoute, Router } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          // auto logout if 401 response returned from api
          if (this.authenticationService.isCurrentUserFederated()) {
            this.redirectFederateAuth();
          } else if (this.authenticationService.currentUserValue != null) {
            localStorage.removeItem("currentUser");
            this.authenticationService.currentUserValue = null;
            this.router.navigate(["sign/login"]);
          }
        }
        const error = err.error.message || err.statusText;
        return throwError(error);
      }),
    );
  }

  private redirectFederateAuth() {
    this.authenticationService.currentUserValue.refreshSession = true;
    const queryParams = { reloadUser: true };
    this.router.navigate(["sign/login/federated"], { queryParams });
  }
}
